<template>
  <div class="payment-dialog">
    <xl-dialog
      v-model="visible"
      :title="$t('design.order.paymentConfirm') || '支付确认'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeDialog"
      width="744px"
    >
      <xl-scrollbar ref="scrollbarRef">
        <div class="payment-container" :class="{'card-pay-container': selectPayment === 'airwallex'}">
          <xl-radio-group
            class="payment-method"
            v-model="selectPayment"
            size="large"
          >
            <xl-radio
              class="payment-radio"
              v-for="item in radioList"
              :key="item.key"
              :label="item.key"
              @change="radioChange(item.key)"
              border
            >
              {{ item.name }}
            </xl-radio>
          </xl-radio-group>

          <!-- 账单明细 -->
          <div class="payment-bill">
            <div class="payment-title">
              <div class="before-title"></div>
              <div class="title-text">
                {{ $t("design.order.billDetail") || "账单明细" }}
              </div>
            </div>
            <div class="bill-detail">
              <div class="product-info">
                <div class="product-name-box">
                  <img
                    class="product-image"
                    :src="$getCdnUrl(props.info?.orderImage)"
                    alt=""
                  />
                  <span class="product-name">{{
                    props.info?.productName
                  }}</span>
                  <span v-if="props.info?.isUrgent" class="is-urgent">{{
                    $t("design.case.soon") || "加急"
                  }}</span>
                </div>
                <div class="bill-count">
                  {{ $t("design.order.totalPrice") || "总计："}}
                  <span v-show="selectPayment === 'airwallex'">{{ formatPrice(props.info?.afterTaxPrice) + " " + props.info?.currency }}</span>
                  <span v-show="selectPayment !== 'airwallex'">{{ props.info?.points }} {{ $t('design.point.pointNumText') }}</span>
                </div>
              </div>
              <div class="product-price">
                <div class="label-value">
                  <div class="label-box">
                    {{ $t("design.orderDetail.caseName") || "案例名称" }}
                  </div>
                  <div class="value-box">{{ props.info?.orderName }}</div>
                </div>
                <div class="label-value">
                  <div class="label-box">
                    {{
                      $t("design.case.designPrice") +
                      "/" +
                      unitMap[props.info?.chargeUnit]
                    }}
                  </div>
                  <div class="value-box">
                    <span v-show="selectPayment === 'airwallex'">{{
                      designPrice
                        ? formatPrice(designPrice / toothNumber) +
                          " " +
                          props.info?.currency +
                          "*" +
                          toothNumber
                        : "-"
                    }}</span>
                    <span v-show="selectPayment !== 'airwallex'">
                      <span v-if="designPoints">{{ designPoints/toothNumber }} {{ $t('design.point.pointNumText') }}{{ '*' + toothNumber }}</span>
                      <span v-else>{{ '-' }}</span>
                    </span>
                  </div>
                </div>
                <div class="label-value">
                  <div class="label-box">
                    {{
                      $t("design.orderDetail.urgentPrice") +
                      "/" +
                      unitMap[props.info?.chargeUnit]
                    }}
                  </div>
                  <div class="value-box">
                    <span v-show="selectPayment === 'airwallex'">{{
                      props.info?.urgentPrice
                        ? formatPrice(props.info?.urgentPrice / toothNumber) +
                          " " +
                          props.info?.currency +
                          "*" +
                          toothNumber
                        : "-"
                    }}</span>
                    <span v-show="selectPayment !== 'airwallex'">
                      <span v-if="props.info?.urgentPoints">{{ props.info?.urgentPoints/toothNumber + ' ' }} {{ $t('design.point.pointNumText') }}{{ '*' + toothNumber }}</span>
                      <span v-else>{{ '-' }}</span>
                    </span>
                  </div>
                </div>
                <div v-show="selectPayment === 'airwallex'" class="label-value tax-item">
                  <div class="label-box tax-box">
                    <xl-tooltip
                      :content="
                        $t('design.case.localTaxRate', {
                          taxRate: props.info?.taxRate,
                        })
                      "
                      :disabled="!props.info?.taxRate || selectPayment !== 'airwallex'"
                      placement="top"
                    >
                      <img v-if="selectPayment === 'airwallex' && props.info?.taxRate" src="../../../assets/image/notice.svg" alt="" />
                    </xl-tooltip>
                    <span :class="{'add-width': selectPayment !== 'airwallex' }">{{ $t("design.case.taxPrice") || "增值税额" }}</span>
                  </div>
                  <div class="value-box">
                    <span v-show="selectPayment === 'airwallex'">{{ taxPrice ? formatPrice(taxPrice) + ' ' + props.info?.currency : "-" }}</span>
                    <span :class="{'add-width': selectPayment !== 'airwallex' }" v-show="selectPayment !== 'airwallex'">{{ '-' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 先临积分 -->
          <div v-if="selectPayment !== 'airwallex'" class="integral">
            <div class="payment-title integral-title">
              <div class="before-title"></div>
              <div class="title-text">
                {{ $t("design.order.integral") || "先临积分" }}
              </div>
            </div>
            <div v-if="selectCardList?.length" class="cards-box">
              <xl-checkbox-group
                v-model="checkCard"
                @change="handleCheckedChange"
              >
                <xl-checkbox
                  class="card-info"
                  size="large"
                  v-for="item in selectCardList"
                  :label="item"
                  :key="item.pointCardID"
                  border
                >
                  <div>
                    <div class="card-point">
                      <span class="card-balance">{{ item.point }}</span>
                      <span class="card-total">{{
                        "/" + item.totalPoint + "-" + $t('design.point.pointNumText')
                      }}</span>
                    </div>
                    <div class="card-detail">
                      <div>{{ $t("design.order.cardNo") }}{{ item.cardNo?.replace(/(\d{4})(?=\d)/g, '$1 ') }}</div>
                      <div>{{ $t("design.order.validTo") }}{{ $convertUTCDateToLocalDate(item.expiredOn) }}</div>
                    </div>
                  </div>
                </xl-checkbox>
              </xl-checkbox-group>
            </div>
            <div v-else class="no-data-box">
                <no-data>
                    <template #text>
                        <span v-if="contactEmail" class="no-dada-span">
                            <span class="no-data-text">{{ $t('design.order.noDebitCardTip') || '暂无储值卡，请联系'}}{{ ' ' }}</span>
                            <a class="contact-email" :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>
                        </span>
                        <span v-else>{{ $t('design.noData') }}</span>
                    </template>
                </no-data>
            </div>
          </div>

          <!-- 信用卡选择 -->
          <div v-else class="integral">
            <div class="payment-title">
              <div class="before-title"></div>
              <div class="title-text">
                {{ $t("design.order.creditCardSelect") || "信用卡选择" }}
              </div>
            </div>
            <div>
              <dropIn ref="dropInRef" :creditCardData="creditCardData" @updateScrollbar="updateScrollbar" @paySucc="dropInSucc"></dropIn>
            </div>
          </div>
        </div>
      </xl-scrollbar>

      <template v-if="selectPayment !== 'airwallex'" #footer>
        <div class="footer">
          <div class="selected-payment">
            <!-- <span v-if="false">
                            <span class="select-point">{{ $t("design.order.selectedPoint") || '已选积分：' }}</span>
                            <span class="point">{{ $t("1500点") }}</span>
                        </span> -->
            <span v-if="showSelectTip" class="select-card-info">{{
              $t("design.order.cancelSelectCardTip") || '请取消其他积分卡后再选择该积分卡'
            }}</span>
          </div>
          <div>
            <xl-button size="large" @click="closeDialog">{{
              $t("design.cancel") || "取消"
            }}</xl-button>
            <xl-button size="large" type="primary" @click="onSubmit" :disabled="submitDisabled" :loading="payLoading">{{
              $t("design.order.confirmPayment") || "确认支付"
            }}</xl-button>
          </div>
        </div>
      </template>
    </xl-dialog>
  </div>
</template>

<script setup>
import {
  XlDialog,
  XlMessage,
  XlTabs,
  XlButton,
  XlRadioGroup,
  XlRadioButton,
  XlRadio,
  XlForm,
  XlFormItem,
  XlCol,
  XlRow,
  XlTooltip,
  XlCheckboxGroup,
  XlCheckbox,
  XlScrollbar,
} from "@shining3d/ui-components";
import {
  ref,
  onMounted,
  onBeforeUnmount,
  nextTick,
  watch,
  computed,
} from "vue";
import { useLang } from "@shining3d/common-module/utils/lang.js";
import dropIn from "./dropIn.vue";
import { $getCdnUrl } from "../../../utils/common.js";
import { unitMap } from "../../case/const";
import { formatPrice, $convertUTCDateToLocalDate } from "../../../utils/common.js";
import NoData from '../../../components/no-data.vue';
import _get from 'lodash/get';
import router from '@/router';
import orderApi from '../../../api/order'
import Bus from '../../../utils/bus.js';

const { $t } = useLang("@shining3d/xl-design-order");
const route = router.currentRoute.value;

const props = defineProps({
  info: {
    type: Object,
  },
  paymentInfo: {
    type: Object,
  },
  platform: {
    type: String
  }
});
const emits = defineEmits(["getDetail", "changePayLoading"]);
const visible = ref(false);
const selectPayment = ref("giftCard");
const radioList = ref([
  { name: $t("design.order.giftCardPayment") || "礼品卡支付", key: "giftCard" },
  {
    name: $t("design.order.valueCardPayment") || "储值卡支付",
    key: "debitCard",
  },
  {
    name: $t("design.order.creditCardPayment") || "信用卡支付",
    key: "airwallex",
  },
]);
// 选中的卡
const checkCard = ref([]);
// 已选积分卡总额大于账单总额，选择积分卡时，提示取消其他积分卡后再选择该积分卡！
const showSelectTip = ref(false);
// 禁用确认支付button
const submitDisabled = computed(() => {
    let total = 0;
    checkCard.value.forEach((item) => {
        total = total + item.point
    })
    return total < props.info?.points || !props.info?.points
});
const closeDialog = () => {
  visible.value = false;
  emits("changePayLoading", false);
};
// 信用卡参数
const creditCardData = ref({
  intentIdData: "",
  clientSecretData: "",
  currencyData: "",
  envData: "",
  payStatus: ''
});
const show = ( airwallexData ) => {
  creditCardData.value.intentIdData = airwallexData.intentIdData || '';
  creditCardData.value.clientSecretData = airwallexData?.clientSecretData || '';
  creditCardData.value.currencyData = airwallexData?.currencyData || '';
  creditCardData.value.envData = airwallexData?.envData || '';
  creditCardData.value.payStatus = airwallexData?.payStatus || '';
  visible.value = true;
};
const dropInRef = ref(null);
const scrollbarRef = ref();
// 跳转邮箱
const contactEmail = _get( window.app.global, 'designContactEmail' );
const selectCardList = ref([])

// 信用卡支付状态及初始化
const creditCardPay = () => {
    if( props.paymentInfo?.airwallex?.payStatus === 'SUCCEEDED' ){
        closeDialog();
        XlMessage({ type: 'success', message: $t('design.orderDetail.acceptSuccess') || '确定设计完成' });
        emits("getDetail");
        if ( props.platform === 'designerService' ) {
            emits('paySucc');
        }  else {
          //跳转到数据下载
          router.push({name: 'orderDetail', params: { id: route?.params?.id }, query: { type: 'dataDownload' }});
        }
    } else {
        // setTimeout(() => {
             nextTick(() => {
                dropInRef.value?.init();
            });
        // }, 1000);
    }
}

// 信用卡支付成功
const dropInSucc = () => {
  closeDialog(); // 关闭支付弹框
  if ( props.platform === 'designerService' ) {
    emits('getDetail');
    emits('paySucc');
  } else {
    //跳转到数据下载
    router.push({name: 'orderDetail', params: { id: route?.params?.id }, query: { type: 'dataDownload' }});
  }
};

const updateScrollbar = () => {
  if( scrollbarRef.value ){
    scrollbarRef.value.update();
  }
}
const radioChange = (paymentName) => {
  selectCardList.value = []
  checkCard.value = []
  showSelectTip.value = false;
  if (paymentName === "airwallex") {
        creditCardPay();
  } else if( paymentName === 'giftCard' ){
    selectCardList.value = props.paymentInfo?.giftCard?.list || []
  } else {
    selectCardList.value = props.paymentInfo?.debitCard?.list || []
  }
    selectCardList.value?.forEach((item) => {
        if( item?.choose ){
            checkCard.value.push(item)
        }
    })
};
watch(() => props.paymentInfo, (val) => {
    if( val ){
        selectPayment.value = val?.bestPayWay
        checkCard.value = []
        // 礼品卡无卡列表，则不展示礼品卡选项
        if( !val?.giftCard?.list || !val?.giftCard?.list?.length ){
            const index = radioList.value.findIndex((item) => item.key === 'giftCard')
            index !== -1 && radioList.value?.splice(index, 1);
        }
        if (selectPayment.value === "airwallex") {
            creditCardPay();
            selectCardList.value = [];
        } else if( selectPayment.value === 'giftCard' ){
            selectCardList.value = val?.giftCard?.list || []
        } else {
            selectCardList.value = val?.debitCard?.list || []
        }
        selectCardList.value?.forEach((item) => {
            if( item?.choose ){
                checkCard.value.push(item)
            }
        })
    }
}, {immediate: true, deep: true});
// 选中卡
const handleCheckedChange = (val) => {
  // 卡已选总额
  let total = 0;
  if( selectPayment.value !== "airwallex"){
    // showSelectTip.value = total >= props.info?.afterTaxPrice
    val?.forEach((item, index) => {
        if( index < val.length-1 ){
            total = total + item.point
        }
    })
    // 已选卡总额>=订单总额，显示提示，并且不再支持勾选
    showSelectTip.value = total >= props.info?.points
    if( showSelectTip.value ){
        checkCard.value.splice(val?.length-1, 1);
    }
  }
};

const payLoading = ref(false);
// 积分支付
const onSubmit = () => {
    const pointCardList = (checkCard.value || []).map((item) => item.pointCardID)
    const data = {
        pointCardList: pointCardList,
        payChoose: selectPayment.value,
        orderID: props.info?.id || route?.params?.id,
    }
    payLoading.value = true;
    orderApi.shiningPay(data).then((res) => {
        if( res && res.status === 'success' ){
            XlMessage({ type: 'success', message: $t('design.creditCard.PaymentSuccess') || '支付成功' });
            closeDialog();
            emits("getDetail");
            Bus.$emit( 'updatePoints' )
            if ( props.platform === 'designerService' ) {
              emits('paySucc');
            } else {
              //跳转到数据下载 
              router.push({name: 'orderDetail', params: { id: route?.params?.id }, query: { type: 'dataDownload' }});
            }
            payLoading.value = false;
        } else {
            payLoading.value = false;
        }
    }).catch(() => {
      payLoading.value = false;
    })
    // emits("getDetail");
};
// 税额
const taxPrice = ref();
// 设计费用
const designPrice = ref(0);
// 设计积分
const designPoints = ref(0);
// 牙号个数
const toothNumber = ref(1);
watch(
  () => props.info,
  (val) => {
    if (val) {
      taxPrice.value = (val?.afterTaxPrice - val?.price) || 0;
      designPrice.value = (val?.price - val?.urgentPrice) || 0;
      // toothNumber.value = (val?.tooths?.split(",")?.length) || 1;
      toothNumber.value = val?.goodsNum || 1;
      designPoints.value = (val.points - val.urgentPoints) || 0;
      if( Number(val.points) === 0 ){
        radioList.value = [
          {
            name: $t("design.order.creditCardPayment") || "信用卡支付",
            key: "airwallex",
          }
        ];
      }
    }
  },
  { immediate: true, deep: true }
);

defineExpose({ show });
</script>

<style lang="scss" scoped>
.payment-dialog {
  font-family: "Alibaba PuHuiTi 2.0";

  .footer {
    display: flex;
    justify-content: space-between;

    .selected-payment {
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;

      .select-point {
        color: #737e99;
      }

      .point {
        color: #2c364e;
      }

      .select-card-info {
        color: #e64c4c;
      }
    }
  }

  .bill-detail {
    width: 100%;
    height: 136px;
    border-radius: 6px;
    padding: 16px;
    box-sizing: border-box;
    background: #f7f8fa;

    .product-info {
      height: 32px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 1px solid #e0e4ea;

      .product-name-box {
        display: flex;
        align-items: center;
      }

      .product-image {
        width: 48px;
        height: 32px;
        border-radius: 4px;
        background-size: contain;
        background-color: #ffffff;
      }

      .product-name {
        display: inline-block;
        font-size: 16px;
        margin-left: 10px;
        font-weight: 500;
        line-height: 24px;
        color: #42526e;
      }

      .is-urgent {
        height: 20px;
        line-height: 20px;
        padding: 0px 15px;
        border-radius: 10px 0px 10px 10px;
        background: #e64c4c;
        color: #fff;
        margin-left: 4px;
        font-size: 12px;
        display: inline-block;
      }

      .bill-count {
        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        text-align: right;
        color: #ff6914;
      }
    }

    .product-price {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;

      .label-box {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #737e99;
        margin-bottom: 4px;
      }

      .value-box {
        font-size: 14px;
        font-weight: 400;
        line-height: 19.6px;
        color: #2c364e;
      }

      .tax-box {
        display: flex;
        align-items: center;

        img {
          margin-right: 2px;
        }
      }
    }
    .add-width{
      padding-left: 18px;
    }
  }

  .payment-title {
    display: flex;
    align-items: center;
    margin-top: 24px;
    margin-bottom: 12px;

    .before-title {
      width: 5px;
      height: 16px;
      background: #5587ff;
      margin-right: 8px;
    }

    .title-text {
      font-size: 16px;
      font-weight: 700;
      line-height: 22.4px;
      color: #2c364e;
    }
  }

  .cards-box {
    .card-info {
      display: inline-block;
      width: 225px;
      height: 100px;
      border-radius: 4px;
      border: 1px solid #e0e4ea;
      box-sizing: border-box;
      margin: 10px 10px 0 0;
      &:hover{
        border: 1px solid #5587FF !important;
      }
      &:nth-child(3n) {
        margin-right: 0 !important;
      }

      .card-point {
        height: 50px;
        padding-left: 8px;
        box-sizing: border-box;
        font-size: 18px;
        font-weight: 600;
        line-height: 26px;
        display: flex;
        align-items: center;

        .card-balance {
          color: #5587ff;
        }

        .card-total {
          color: #a5acbe;
        }
      }

      .card-detail {
        height: 48px;
        width: 223px;
        padding: 6px 8px;
        border-radius: 0 0 4px 4px;
        box-sizing: border-box;
        background: #f7f8fa;
        font-size: 12px;
        font-weight: 400;
        line-height: 18px;
        color: #737e99;
      }
    }
  }
  .no-data-box{
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-top: 28px;
    .no-data-text{
        color: #BDC3CD;
    }
    .contact-email{
        color: #5587FF;
        cursor: pointer;
    }
    .no-dada-span {
        white-space: nowrap;
    }
  }
  .integral {
    .integral-title {
      // margin-bottom: -4px !important;
      margin-bottom: 2px !important;
    }

    :deep(.el-checkbox) {
      padding: 0 !important;
      position: relative;

      .el-checkbox__label {
        padding-left: 0 !important;
      }
    }

    :deep(.el-checkbox__input) {
      position: absolute;
      top: 17px;
      right: 8px;

      .el-checkbox__inner {
        width: 16px;
        height: 16px;
      }
    }
    :deep(.el-checkbox.is-bordered.is-checked){
        border: 1px solid #5587FF !important;
    }
  }

  .payment-method {
    .payment-radio {
      height: 36px;
      box-sizing: border-box;
      padding: 8px 16px;
      margin-right: 8px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      border: 2px solid #e0e4ea;
      color: #42526e;

      :deep(.el-radio__label) {
        padding-left: 0 !important;
      }

      :deep(.el-radio__input) {
        display: none;
      }
      &:hover{
        border: 2px solid #5587ff !important;
      }
    }

    :deep(.el-radio.is-bordered.is-checked) {
      background: #5587ff !important;
      border: 2px solid #5587ff !important;

      .el-radio__label {
        color: #ffffff !important;
      }
    }
  }
    .payment-container {
        height: 505px;
        margin: 0 14px;
    }
    .card-pay-container{
        height: 575px !important;
    }
    :deep(.xl-dialog.el-dialog){
      --el-dialog-margin-top: auto;
      top: 50%;
      transform: translateY(-50%);
      .el-dialog__body{
        margin: 0 10px !important;
      }
    }
    .tax-item{
      min-width: 45px;
    }
}
</style>
